export class BatchValidateResourceConfigurationRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchValidateResourceConfigurationRequest.attributeTypeMap;
    }
    constructor() {
    }
}
